import axios from 'axios';
import React, { Component } from "react";
import Select from 'react-select';
import { FaTrash, FaInfoCircle, FaRegClock } from 'react-icons/fa';
import { SheetJSFT } from '../screens/types.js';
import XLSX from 'xlsx';
import { make_cols } from '../screens/MakeColumns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';
import 'date-fns';
import jscolor from '../jscolor';
import DateFnsUtils from '@date-io/date-fns';
import Loader from 'react-loader-spinner';
import moment from 'moment';
import momentTz from 'moment-timezone';
import '../App.css'

import {
  Input,
  createMuiTheme,
  MuiThemeProvider,
  Button,
} from "@material-ui/core";
import { withStyles, } from "@material-ui/core";

import { generateData, seatSectionKeys, seatSection } from '../services/userServices'
import TopBar from "./TopBar";

import { getAssetsInfo } from '../services/userServices'
import { Typography } from "@material-ui/core";


const theme = createMuiTheme({
  overrides: {
    MuiChip: {
      root: {
        fontSize: "11px",
        color: "#3c4043",
        marginTop: 20,
        height: 25,
        backgroundColor: "rgba(0, 0, 0, 0.10)",
        padding: "3px 5px"
      },
      deleteIcon: {
        width: 14,
        height: 14,
        margin: 0
      },
      label: {
        color: "#3c4043",
        cursor: "pointer",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: "11px",
        margin: "0 6px",
        padding: "1px",
        paddingLeft: 0,
        paddingRight: 0,
        marginRight: 0,
        fontWeight: 600
      }
    }
  },
  typography: {
    useNextVariants: true
  },

});

const timeZones = [
  {
    "name": "(GMT-11:00) Niue Time",
    "value": "Pacific/Niue"
  },
  {
    "name": "(GMT-11:00) Samoa Standard Time",
    "value": "Pacific/Pago_Pago"
  },
  {
    "name": "(GMT-10:00) Cook Islands Standard Time",
    "value": "Pacific/Rarotonga"
  },
  {
    "name": "(GMT-10:00) Hawaii-Aleutian Standard Time",
    "value": "Pacific/Honolulu"
  },
  {
    "name": "(GMT-10:00) Hawaii-Aleutian Time",
    "value": "America/Adak"
  },
  {
    "name": "(GMT-10:00) Tahiti Time",
    "value": "Pacific/Tahiti"
  },
  {
    "name": "(GMT-09:30) Marquesas Time",
    "value": "Pacific/Marquesas"
  },
  {
    "name": "(GMT-09:00) Alaska Time - Anchorage",
    "value": "America/Anchorage"
  },
  {
    "name": "(GMT-09:00) Alaska Time - Juneau",
    "value": "America/Juneau"
  },
  {
    "name": "(GMT-09:00) Alaska Time - Metlakatla",
    "value": "America/Metlakatla"
  },
  {
    "name": "(GMT-09:00) Alaska Time - Nome",
    "value": "America/Nome"
  },
  {
    "name": "(GMT-09:00) Alaska Time - Sitka",
    "value": "America/Sitka"
  },
  {
    "name": "(GMT-09:00) Alaska Time - Yakutat",
    "value": "America/Yakutat"
  },
  {
    "name": "(GMT-09:00) Gambier Time",
    "value": "Pacific/Gambier"
  },
  {
    "name": "(GMT-08:00) Pacific Time - Dawson",
    "value": "America/Dawson"
  },
  {
    "name": "(GMT-08:00) Pacific Time - Los Angeles",
    "value": "America/Los_Angeles"
  },
  {
    "name": "(GMT-08:00) Pacific Time - Tijuana",
    "value": "America/Tijuana"
  },
  {
    "name": "(GMT-08:00) Pacific Time - Vancouver",
    "value": "America/Vancouver"
  },
  {
    "name": "(GMT-08:00) Pacific Time - Whitehorse",
    "value": "America/Whitehorse"
  },
  {
    "name": "(GMT-08:00) Pitcairn Time",
    "value": "Pacific/Pitcairn"
  },
  {
    "name": "(GMT-07:00) Mexican Pacific Standard Time",
    "value": "America/Hermosillo"
  },
  {
    "name": "(GMT-07:00) Mexican Pacific Time - Chihuahua",
    "value": "America/Chihuahua"
  },
  {
    "name": "(GMT-07:00) Mexican Pacific Time - Mazatlan",
    "value": "America/Mazatlan"
  },
  {
    "name": "(GMT-07:00) Mountain Standard Time - Creston",
    "value": "America/Creston"
  },
  {
    "name": "(GMT-07:00) Mountain Standard Time - Dawson Creek",
    "value": "America/Dawson_Creek"
  },
  {
    "name": "(GMT-07:00) Mountain Standard Time - Fort Nelson",
    "value": "America/Fort_Nelson"
  },
  {
    "name": "(GMT-07:00) Mountain Standard Time - Phoenix",
    "value": "America/Phoenix"
  },
  {
    "name": "(GMT-07:00) Mountain Time - Boise",
    "value": "America/Boise"
  },
  {
    "name": "(GMT-07:00) Mountain Time - Cambridge Bay",
    "value": "America/Cambridge_Bay"
  },
  {
    "name": "(GMT-07:00) Mountain Time - Denver",
    "value": "America/Denver"
  },
  {
    "name": "(GMT-07:00) Mountain Time - Edmonton",
    "value": "America/Edmonton"
  },
  {
    "name": "(GMT-07:00) Mountain Time - Inuvik",
    "value": "America/Inuvik"
  },
  {
    "name": "(GMT-07:00) Mountain Time - Ojinaga",
    "value": "America/Ojinaga"
  },
  {
    "name": "(GMT-07:00) Mountain Time - Yellowknife",
    "value": "America/Yellowknife"
  },
  {
    "name": "(GMT-06:00) Central Standard Time - Belize",
    "value": "America/Belize"
  },
  {
    "name": "(GMT-06:00) Central Standard Time - Costa Rica",
    "value": "America/Costa_Rica"
  },
  {
    "name": "(GMT-06:00) Central Standard Time - El Salvador",
    "value": "America/El_Salvador"
  },
  {
    "name": "(GMT-06:00) Central Standard Time - Guatemala",
    "value": "America/Guatemala"
  },
  {
    "name": "(GMT-06:00) Central Standard Time - Managua",
    "value": "America/Managua"
  },
  {
    "name": "(GMT-06:00) Central Standard Time - Regina",
    "value": "America/Regina"
  },
  {
    "name": "(GMT-06:00) Central Standard Time - Swift Current",
    "value": "America/Swift_Current"
  },
  {
    "name": "(GMT-06:00) Central Standard Time - Tegucigalpa",
    "value": "America/Tegucigalpa"
  },
  {
    "name": "(GMT-06:00) Central Time - Bahia Banderas",
    "value": "America/Bahia_Banderas"
  },
  {
    "name": "(GMT-06:00) Central Time - Beulah, North Dakota",
    "value": "America/North_Dakota/Beulah"
  },
  {
    "name": "(GMT-06:00) Central Time - Center, North Dakota",
    "value": "America/North_Dakota/Center"
  },
  {
    "name": "(GMT-06:00) Central Time - Chicago",
    "value": "America/Chicago"
  },
  {
    "name": "(GMT-06:00) Central Time - Knox, Indiana",
    "value": "America/Indiana/Knox"
  },
  {
    "name": "(GMT-06:00) Central Time - Matamoros",
    "value": "America/Matamoros"
  },
  {
    "name": "(GMT-06:00) Central Time - Menominee",
    "value": "America/Menominee"
  },
  {
    "name": "(GMT-06:00) Central Time - Merida",
    "value": "America/Merida"
  },
  {
    "name": "(GMT-06:00) Central Time - Mexico City",
    "value": "America/Mexico_City"
  },
  {
    "name": "(GMT-06:00) Central Time - Monterrey",
    "value": "America/Monterrey"
  },
  {
    "name": "(GMT-06:00) Central Time - New Salem, North Dakota",
    "value": "America/North_Dakota/New_Salem"
  },
  {
    "name": "(GMT-06:00) Central Time - Rainy River",
    "value": "America/Rainy_River"
  },
  {
    "name": "(GMT-06:00) Central Time - Rankin Inlet",
    "value": "America/Rankin_Inlet"
  },
  {
    "name": "(GMT-06:00) Central Time - Resolute",
    "value": "America/Resolute"
  },
  {
    "name": "(GMT-06:00) Central Time - Tell City, Indiana",
    "value": "America/Indiana/Tell_City"
  },
  {
    "name": "(GMT-06:00) Central Time - Winnipeg",
    "value": "America/Winnipeg"
  },
  {
    "name": "(GMT-06:00) Galapagos Time",
    "value": "Pacific/Galapagos"
  },
  {
    "name": "(GMT-05:00) Acre Standard Time - Eirunepe",
    "value": "America/Eirunepe"
  },
  {
    "name": "(GMT-05:00) Acre Standard Time - Rio Branco",
    "value": "America/Rio_Branco"
  },
  {
    "name": "(GMT-05:00) Colombia Standard Time",
    "value": "America/Bogota"
  },
  {
    "name": "(GMT-05:00) Cuba Time",
    "value": "America/Havana"
  },
  {
    "name": "(GMT-05:00) Easter Island Time",
    "value": "Pacific/Easter"
  },
  {
    "name": "(GMT-05:00) Eastern Standard Time - Atikokan",
    "value": "America/Atikokan"
  },
  {
    "name": "(GMT-05:00) Eastern Standard Time - Cancun",
    "value": "America/Cancun"
  },
  {
    "name": "(GMT-05:00) Eastern Standard Time - Jamaica",
    "value": "America/Jamaica"
  },
  {
    "name": "(GMT-05:00) Eastern Standard Time - Panama",
    "value": "America/Panama"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Detroit",
    "value": "America/Detroit"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Grand Turk",
    "value": "America/Grand_Turk"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Indianapolis",
    "value": "America/Indiana/Indianapolis"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Iqaluit",
    "value": "America/Iqaluit"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Louisville",
    "value": "America/Kentucky/Louisville"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Marengo, Indiana",
    "value": "America/Indiana/Marengo"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Monticello, Kentucky",
    "value": "America/Kentucky/Monticello"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Nassau",
    "value": "America/Nassau"
  },
  {
    "name": "(GMT-05:00) Eastern Time - New York",
    "value": "America/New_York"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Nipigon",
    "value": "America/Nipigon"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Pangnirtung",
    "value": "America/Pangnirtung"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Petersburg, Indiana",
    "value": "America/Indiana/Petersburg"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Port-au-Prince",
    "value": "America/Port-au-Prince"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Thunder Bay",
    "value": "America/Thunder_Bay"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Toronto",
    "value": "America/Toronto"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Vevay, Indiana",
    "value": "America/Indiana/Vevay"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Vincennes, Indiana",
    "value": "America/Indiana/Vincennes"
  },
  {
    "name": "(GMT-05:00) Eastern Time - Winamac, Indiana",
    "value": "America/Indiana/Winamac"
  },
  {
    "name": "(GMT-05:00) Ecuador Time",
    "value": "America/Guayaquil"
  },
  {
    "name": "(GMT-05:00) Peru Standard Time",
    "value": "America/Lima"
  },
  {
    "name": "(GMT-04:00) Amazon Standard Time - Boa Vista",
    "value": "America/Boa_Vista"
  },
  {
    "name": "(GMT-04:00) Amazon Standard Time - Campo Grande",
    "value": "America/Campo_Grande"
  },
  {
    "name": "(GMT-04:00) Amazon Standard Time - Cuiaba",
    "value": "America/Cuiaba"
  },
  {
    "name": "(GMT-04:00) Amazon Standard Time - Manaus",
    "value": "America/Manaus"
  },
  {
    "name": "(GMT-04:00) Amazon Standard Time - Porto Velho",
    "value": "America/Porto_Velho"
  },
  {
    "name": "(GMT-04:00) Atlantic Standard Time - Barbados",
    "value": "America/Barbados"
  },
  {
    "name": "(GMT-04:00) Atlantic Standard Time - Blanc-Sablon",
    "value": "America/Blanc-Sablon"
  },
  {
    "name": "(GMT-04:00) Atlantic Standard Time - Curaçao",
    "value": "America/Curacao"
  },
  {
    "name": "(GMT-04:00) Atlantic Standard Time - Martinique",
    "value": "America/Martinique"
  },
  {
    "name": "(GMT-04:00) Atlantic Standard Time - Port of Spain",
    "value": "America/Port_of_Spain"
  },
  {
    "name": "(GMT-04:00) Atlantic Standard Time - Puerto Rico",
    "value": "America/Puerto_Rico"
  },
  {
    "name": "(GMT-04:00) Atlantic Standard Time - Santo Domingo",
    "value": "America/Santo_Domingo"
  },
  {
    "name": "(GMT-04:00) Atlantic Time - Bermuda",
    "value": "Atlantic/Bermuda"
  },
  {
    "name": "(GMT-04:00) Atlantic Time - Glace Bay",
    "value": "America/Glace_Bay"
  },
  {
    "name": "(GMT-04:00) Atlantic Time - Goose Bay",
    "value": "America/Goose_Bay"
  },
  {
    "name": "(GMT-04:00) Atlantic Time - Halifax",
    "value": "America/Halifax"
  },
  {
    "name": "(GMT-04:00) Atlantic Time - Moncton",
    "value": "America/Moncton"
  },
  {
    "name": "(GMT-04:00) Atlantic Time - Thule",
    "value": "America/Thule"
  },
  {
    "name": "(GMT-04:00) Bolivia Time",
    "value": "America/La_Paz"
  },
  {
    "name": "(GMT-04:00) Guyana Time",
    "value": "America/Guyana"
  },
  {
    "name": "(GMT-04:00) Venezuela Time",
    "value": "America/Caracas"
  },
  {
    "name": "(GMT-03:30) Newfoundland Time",
    "value": "America/St_Johns"
  },
  {
    "name": "(GMT-03:00) Argentina Standard Time - Buenos Aires",
    "value": "America/Argentina/Buenos_Aires"
  },
  {
    "name": "(GMT-03:00) Argentina Standard Time - Catamarca",
    "value": "America/Argentina/Catamarca"
  },
  {
    "name": "(GMT-03:00) Argentina Standard Time - Cordoba",
    "value": "America/Argentina/Cordoba"
  },
  {
    "name": "(GMT-03:00) Argentina Standard Time - Jujuy",
    "value": "America/Argentina/Jujuy"
  },
  {
    "name": "(GMT-03:00) Argentina Standard Time - La Rioja",
    "value": "America/Argentina/La_Rioja"
  },
  {
    "name": "(GMT-03:00) Argentina Standard Time - Mendoza",
    "value": "America/Argentina/Mendoza"
  },
  {
    "name": "(GMT-03:00) Argentina Standard Time - Rio Gallegos",
    "value": "America/Argentina/Rio_Gallegos"
  },
  {
    "name": "(GMT-03:00) Argentina Standard Time - Salta",
    "value": "America/Argentina/Salta"
  },
  {
    "name": "(GMT-03:00) Argentina Standard Time - San Juan",
    "value": "America/Argentina/San_Juan"
  },
  {
    "name": "(GMT-03:00) Argentina Standard Time - Tucuman",
    "value": "America/Argentina/Tucuman"
  },
  {
    "name": "(GMT-03:00) Argentina Standard Time - Ushuaia",
    "value": "America/Argentina/Ushuaia"
  },
  {
    "name": "(GMT-03:00) Brasilia Standard Time - Araguaina",
    "value": "America/Araguaina"
  },
  {
    "name": "(GMT-03:00) Brasilia Standard Time - Bahia",
    "value": "America/Bahia"
  },
  {
    "name": "(GMT-03:00) Brasilia Standard Time - Belem",
    "value": "America/Belem"
  },
  {
    "name": "(GMT-03:00) Brasilia Standard Time - Fortaleza",
    "value": "America/Fortaleza"
  },
  {
    "name": "(GMT-03:00) Brasilia Standard Time - Maceio",
    "value": "America/Maceio"
  },
  {
    "name": "(GMT-03:00) Brasilia Standard Time - Recife",
    "value": "America/Recife"
  },
  {
    "name": "(GMT-03:00) Brasilia Standard Time - Santarem",
    "value": "America/Santarem"
  },
  {
    "name": "(GMT-03:00) Brasilia Standard Time - Sao Paulo",
    "value": "America/Sao_Paulo"
  },
  {
    "name": "(GMT-03:00) Chile Time",
    "value": "America/Santiago"
  },
  {
    "name": "(GMT-03:00) Falkland Islands Standard Time",
    "value": "Atlantic/Stanley"
  },
  {
    "name": "(GMT-03:00) French Guiana Time",
    "value": "America/Cayenne"
  },
  {
    "name": "(GMT-03:00) Palmer Time",
    "value": "Antarctica/Palmer"
  },
  {
    "name": "(GMT-03:00) Paraguay Time",
    "value": "America/Asuncion"
  },
  {
    "name": "(GMT-03:00) Punta Arenas Time",
    "value": "America/Punta_Arenas"
  },
  {
    "name": "(GMT-03:00) Rothera Time",
    "value": "Antarctica/Rothera"
  },
  {
    "name": "(GMT-03:00) St Pierre & Miquelon Time",
    "value": "America/Miquelon"
  },
  {
    "name": "(GMT-03:00) Suriname Time",
    "value": "America/Paramaribo"
  },
  {
    "name": "(GMT-03:00) Uruguay Standard Time",
    "value": "America/Montevideo"
  },
  {
    "name": "(GMT-03:00) West Greenland Time",
    "value": "America/Godthab"
  },
  {
    "name": "(GMT-03:00) Western Argentina Standard Time",
    "value": "America/Argentina/San_Luis"
  },
  {
    "name": "(GMT-02:00) Fernando de Noronha Standard Time",
    "value": "America/Noronha"
  },
  {
    "name": "(GMT-02:00) South Georgia Time",
    "value": "Atlantic/South_Georgia"
  },
  {
    "name": "(GMT-01:00) Azores Time",
    "value": "Atlantic/Azores"
  },
  {
    "name": "(GMT-01:00) Cape Verde Standard Time",
    "value": "Atlantic/Cape_Verde"
  },
  {
    "name": "(GMT-01:00) East Greenland Time",
    "value": "America/Scoresbysund"
  },
  {
    "name": "(GMT+00:00) Coordinated Universal Time",
    "value": "UTC"
  },
  {
    "name": "(GMT+00:00) Greenwich Mean Time",
    "value": "Etc/GMT"
  },
  {
    "name": "(GMT+00:00) Greenwich Mean Time - Abidjan",
    "value": "Africa/Abidjan"
  },
  {
    "name": "(GMT+00:00) Greenwich Mean Time - Accra",
    "value": "Africa/Accra"
  },
  {
    "name": "(GMT+00:00) Greenwich Mean Time - Bissau",
    "value": "Africa/Bissau"
  },
  {
    "name": "(GMT+00:00) Greenwich Mean Time - Danmarkshavn",
    "value": "America/Danmarkshavn"
  },
  {
    "name": "(GMT+00:00) Greenwich Mean Time - Monrovia",
    "value": "Africa/Monrovia"
  },
  {
    "name": "(GMT+00:00) Greenwich Mean Time - Reykjavik",
    "value": "Atlantic/Reykjavik"
  },
  {
    "name": "(GMT+00:00) Greenwich Mean Time - São Tomé",
    "value": "Africa/Sao_Tome"
  },
  {
    "name": "(GMT+00:00) Ireland Time",
    "value": "Europe/Dublin"
  },
  {
    "name": "(GMT+00:00) Troll Time",
    "value": "Antarctica/Troll"
  },
  {
    "name": "(GMT+00:00) United Kingdom Time",
    "value": "Europe/London"
  },
  {
    "name": "(GMT+00:00) Western European Time - Canary",
    "value": "Atlantic/Canary"
  },
  {
    "name": "(GMT+00:00) Western European Time - Faroe",
    "value": "Atlantic/Faroe"
  },
  {
    "name": "(GMT+00:00) Western European Time - Lisbon",
    "value": "Europe/Lisbon"
  },
  {
    "name": "(GMT+00:00) Western European Time - Madeira",
    "value": "Atlantic/Madeira"
  },
  {
    "name": "(GMT+01:00) Central European Standard Time - Algiers",
    "value": "Africa/Algiers"
  },
  {
    "name": "(GMT+01:00) Central European Standard Time - Tunis",
    "value": "Africa/Tunis"
  },
  {
    "name": "(GMT+01:00) Central European Time - Amsterdam",
    "value": "Europe/Amsterdam"
  },
  {
    "name": "(GMT+01:00) Central European Time - Andorra",
    "value": "Europe/Andorra"
  },
  {
    "name": "(GMT+01:00) Central European Time - Belgrade",
    "value": "Europe/Belgrade"
  },
  {
    "name": "(GMT+01:00) Central European Time - Berlin",
    "value": "Europe/Berlin"
  },
  {
    "name": "(GMT+01:00) Central European Time - Brussels",
    "value": "Europe/Brussels"
  },
  {
    "name": "(GMT+01:00) Central European Time - Budapest",
    "value": "Europe/Budapest"
  },
  {
    "name": "(GMT+01:00) Central European Time - Ceuta",
    "value": "Africa/Ceuta"
  },
  {
    "name": "(GMT+01:00) Central European Time - Copenhagen",
    "value": "Europe/Copenhagen"
  },
  {
    "name": "(GMT+01:00) Central European Time - Gibraltar",
    "value": "Europe/Gibraltar"
  },
  {
    "name": "(GMT+01:00) Central European Time - Luxembourg",
    "value": "Europe/Luxembourg"
  },
  {
    "name": "(GMT+01:00) Central European Time - Madrid",
    "value": "Europe/Madrid"
  },
  {
    "name": "(GMT+01:00) Central European Time - Malta",
    "value": "Europe/Malta"
  },
  {
    "name": "(GMT+01:00) Central European Time - Monaco",
    "value": "Europe/Monaco"
  },
  {
    "name": "(GMT+01:00) Central European Time - Oslo",
    "value": "Europe/Oslo"
  },
  {
    "name": "(GMT+01:00) Central European Time - Paris",
    "value": "Europe/Paris"
  },
  {
    "name": "(GMT+01:00) Central European Time - Prague",
    "value": "Europe/Prague"
  },
  {
    "name": "(GMT+01:00) Central European Time - Rome",
    "value": "Europe/Rome"
  },
  {
    "name": "(GMT+01:00) Central European Time - Stockholm",
    "value": "Europe/Stockholm"
  },
  {
    "name": "(GMT+01:00) Central European Time - Tirane",
    "value": "Europe/Tirane"
  },
  {
    "name": "(GMT+01:00) Central European Time - Vienna",
    "value": "Europe/Vienna"
  },
  {
    "name": "(GMT+01:00) Central European Time - Warsaw",
    "value": "Europe/Warsaw"
  },
  {
    "name": "(GMT+01:00) Central European Time - Zurich",
    "value": "Europe/Zurich"
  },
  {
    "name": "(GMT+01:00) Morocco Time",
    "value": "Africa/Casablanca"
  },
  {
    "name": "(GMT+01:00) West Africa Standard Time - Lagos",
    "value": "Africa/Lagos"
  },
  {
    "name": "(GMT+01:00) West Africa Standard Time - Ndjamena",
    "value": "Africa/Ndjamena"
  },
  {
    "name": "(GMT+01:00) Western Sahara Time",
    "value": "Africa/El_Aaiun"
  },
  {
    "name": "(GMT+02:00) Central Africa Time - Khartoum",
    "value": "Africa/Khartoum"
  },
  {
    "name": "(GMT+02:00) Central Africa Time - Maputo",
    "value": "Africa/Maputo"
  },
  {
    "name": "(GMT+02:00) Central Africa Time - Windhoek",
    "value": "Africa/Windhoek"
  },
  {
    "name": "(GMT+02:00) Eastern European Standard Time - Cairo",
    "value": "Africa/Cairo"
  },
  {
    "name": "(GMT+02:00) Eastern European Standard Time - Kaliningrad",
    "value": "Europe/Kaliningrad"
  },
  {
    "name": "(GMT+02:00) Eastern European Standard Time - Tripoli",
    "value": "Africa/Tripoli"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Amman",
    "value": "Asia/Amman"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Athens",
    "value": "Europe/Athens"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Beirut",
    "value": "Asia/Beirut"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Bucharest",
    "value": "Europe/Bucharest"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Chisinau",
    "value": "Europe/Chisinau"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Damascus",
    "value": "Asia/Damascus"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Gaza",
    "value": "Asia/Gaza"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Hebron",
    "value": "Asia/Hebron"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Helsinki",
    "value": "Europe/Helsinki"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Kiev",
    "value": "Europe/Kiev"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Nicosia",
    "value": "Asia/Nicosia"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Riga",
    "value": "Europe/Riga"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Sofia",
    "value": "Europe/Sofia"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Tallinn",
    "value": "Europe/Tallinn"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Uzhhorod",
    "value": "Europe/Uzhgorod"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Vilnius",
    "value": "Europe/Vilnius"
  },
  {
    "name": "(GMT+02:00) Eastern European Time - Zaporozhye",
    "value": "Europe/Zaporozhye"
  },
  {
    "name": "(GMT+02:00) Famagusta Time",
    "value": "Asia/Famagusta"
  },
  {
    "name": "(GMT+02:00) Israel Time",
    "value": "Asia/Jerusalem"
  },
  {
    "name": "(GMT+02:00) South Africa Standard Time",
    "value": "Africa/Johannesburg"
  },
  {
    "name": "(GMT+03:00) Arabian Standard Time - Baghdad",
    "value": "Asia/Baghdad"
  },
  {
    "name": "(GMT+03:00) Arabian Standard Time - Qatar",
    "value": "Asia/Qatar"
  },
  {
    "name": "(GMT+03:00) Arabian Standard Time - Riyadh",
    "value": "Asia/Riyadh"
  },
  {
    "name": "(GMT+03:00) East Africa Time - Juba",
    "value": "Africa/Juba"
  },
  {
    "name": "(GMT+03:00) East Africa Time - Nairobi",
    "value": "Africa/Nairobi"
  },
  {
    "name": "(GMT+03:00) Kirov Time",
    "value": "Europe/Kirov"
  },
  {
    "name": "(GMT+03:00) Moscow Standard Time - Minsk",
    "value": "Europe/Minsk"
  },
  {
    "name": "(GMT+03:00) Moscow Standard Time - Moscow",
    "value": "Europe/Moscow"
  },
  {
    "name": "(GMT+03:00) Moscow Standard Time - Simferopol",
    "value": "Europe/Simferopol"
  },
  {
    "name": "(GMT+03:00) Syowa Time",
    "value": "Antarctica/Syowa"
  },
  {
    "name": "(GMT+03:00) Turkey Time",
    "value": "Europe/Istanbul"
  },
  {
    "name": "(GMT+03:30) Iran Time",
    "value": "Asia/Tehran"
  },
  {
    "name": "(GMT+04:00) Armenia Standard Time",
    "value": "Asia/Yerevan"
  },
  {
    "name": "(GMT+04:00) Astrakhan Time",
    "value": "Europe/Astrakhan"
  },
  {
    "name": "(GMT+04:00) Azerbaijan Standard Time",
    "value": "Asia/Baku"
  },
  {
    "name": "(GMT+04:00) Georgia Standard Time",
    "value": "Asia/Tbilisi"
  },
  {
    "name": "(GMT+04:00) Gulf Standard Time",
    "value": "Asia/Dubai"
  },
  {
    "name": "(GMT+04:00) Mauritius Standard Time",
    "value": "Indian/Mauritius"
  },
  {
    "name": "(GMT+04:00) Réunion Time",
    "value": "Indian/Reunion"
  },
  {
    "name": "(GMT+04:00) Samara Standard Time",
    "value": "Europe/Samara"
  },
  {
    "name": "(GMT+04:00) Saratov Time",
    "value": "Europe/Saratov"
  },
  {
    "name": "(GMT+04:00) Seychelles Time",
    "value": "Indian/Mahe"
  },
  {
    "name": "(GMT+04:00) Ulyanovsk Time",
    "value": "Europe/Ulyanovsk"
  },
  {
    "name": "(GMT+04:00) Volgograd Standard Time",
    "value": "Europe/Volgograd"
  },
  {
    "name": "(GMT+04:30) Afghanistan Time",
    "value": "Asia/Kabul"
  },
  {
    "name": "(GMT+05:00) French Southern & Antarctic Time",
    "value": "Indian/Kerguelen"
  },
  {
    "name": "(GMT+05:00) Maldives Time",
    "value": "Indian/Maldives"
  },
  {
    "name": "(GMT+05:00) Mawson Time",
    "value": "Antarctica/Mawson"
  },
  {
    "name": "(GMT+05:00) Pakistan Standard Time",
    "value": "Asia/Karachi"
  },
  {
    "name": "(GMT+05:00) Tajikistan Time",
    "value": "Asia/Dushanbe"
  },
  {
    "name": "(GMT+05:00) Turkmenistan Standard Time",
    "value": "Asia/Ashgabat"
  },
  {
    "name": "(GMT+05:00) Uzbekistan Standard Time - Samarkand",
    "value": "Asia/Samarkand"
  },
  {
    "name": "(GMT+05:00) Uzbekistan Standard Time - Tashkent",
    "value": "Asia/Tashkent"
  },
  {
    "name": "(GMT+05:00) West Kazakhstan Time - Aqtau",
    "value": "Asia/Aqtau"
  },
  {
    "name": "(GMT+05:00) West Kazakhstan Time - Aqtobe",
    "value": "Asia/Aqtobe"
  },
  {
    "name": "(GMT+05:00) West Kazakhstan Time - Atyrau",
    "value": "Asia/Atyrau"
  },
  {
    "name": "(GMT+05:00) West Kazakhstan Time - Oral",
    "value": "Asia/Oral"
  },
  {
    "name": "(GMT+05:00) West Kazakhstan Time - Qyzylorda",
    "value": "Asia/Qyzylorda"
  },
  {
    "name": "(GMT+05:00) Yekaterinburg Standard Time",
    "value": "Asia/Yekaterinburg"
  },
  {
    "name": "(GMT+05:30) India Standard Time - Colombo",
    "value": "Asia/Colombo"
  },
  {
    "name": "(GMT+05:30) India Standard Time - Kolkata",
    "value": "Asia/Kolkata"
  },
  {
    "name": "(GMT+05:45) Nepal Time",
    "value": "Asia/Kathmandu"
  },
  {
    "name": "(GMT+06:00) Bangladesh Standard Time",
    "value": "Asia/Dhaka"
  },
  {
    "name": "(GMT+06:00) Bhutan Time",
    "value": "Asia/Thimphu"
  },
  {
    "name": "(GMT+06:00) East Kazakhstan Time - Almaty",
    "value": "Asia/Almaty"
  },
  {
    "name": "(GMT+06:00) East Kazakhstan Time - Kostanay",
    "value": "Asia/Qostanay"
  },
  {
    "name": "(GMT+06:00) Indian Ocean Time",
    "value": "Indian/Chagos"
  },
  {
    "name": "(GMT+06:00) Kyrgyzstan Time",
    "value": "Asia/Bishkek"
  },
  {
    "name": "(GMT+06:00) Omsk Standard Time",
    "value": "Asia/Omsk"
  },
  {
    "name": "(GMT+06:00) Urumqi Time",
    "value": "Asia/Urumqi"
  },
  {
    "name": "(GMT+06:00) Vostok Time",
    "value": "Antarctica/Vostok"
  },
  {
    "name": "(GMT+06:30) Cocos Islands Time",
    "value": "Indian/Cocos"
  },
  {
    "name": "(GMT+06:30) Myanmar Time",
    "value": "Asia/Yangon"
  },
  {
    "name": "(GMT+07:00) Barnaul Time",
    "value": "Asia/Barnaul"
  },
  {
    "name": "(GMT+07:00) Christmas Island Time",
    "value": "Indian/Christmas"
  },
  {
    "name": "(GMT+07:00) Davis Time",
    "value": "Antarctica/Davis"
  },
  {
    "name": "(GMT+07:00) Hovd Standard Time",
    "value": "Asia/Hovd"
  },
  {
    "name": "(GMT+07:00) Indochina Time - Bangkok",
    "value": "Asia/Bangkok"
  },
  {
    "name": "(GMT+07:00) Indochina Time - Ho Chi Minh City",
    "value": "Asia/Ho_Chi_Minh"
  },
  {
    "name": "(GMT+07:00) Krasnoyarsk Standard Time - Krasnoyarsk",
    "value": "Asia/Krasnoyarsk"
  },
  {
    "name": "(GMT+07:00) Krasnoyarsk Standard Time - Novokuznetsk",
    "value": "Asia/Novokuznetsk"
  },
  {
    "name": "(GMT+07:00) Novosibirsk Standard Time",
    "value": "Asia/Novosibirsk"
  },
  {
    "name": "(GMT+07:00) Tomsk Time",
    "value": "Asia/Tomsk"
  },
  {
    "name": "(GMT+07:00) Western Indonesia Time - Jakarta",
    "value": "Asia/Jakarta"
  },
  {
    "name": "(GMT+07:00) Western Indonesia Time - Pontianak",
    "value": "Asia/Pontianak"
  },
  {
    "name": "(GMT+08:00) Australian Western Standard Time - Casey",
    "value": "Antarctica/Casey"
  },
  {
    "name": "(GMT+08:00) Australian Western Standard Time - Perth",
    "value": "Australia/Perth"
  },
  {
    "name": "(GMT+08:00) Brunei Darussalam Time",
    "value": "Asia/Brunei"
  },
  {
    "name": "(GMT+08:00) Central Indonesia Time",
    "value": "Asia/Makassar"
  },
  {
    "name": "(GMT+08:00) China Standard Time - Macao",
    "value": "Asia/Macau"
  },
  {
    "name": "(GMT+08:00) China Standard Time - Shanghai",
    "value": "Asia/Shanghai"
  },
  {
    "name": "(GMT+08:00) Choibalsan Standard Time",
    "value": "Asia/Choibalsan"
  },
  {
    "name": "(GMT+08:00) Hong Kong Standard Time",
    "value": "Asia/Hong_Kong"
  },
  {
    "name": "(GMT+08:00) Irkutsk Standard Time",
    "value": "Asia/Irkutsk"
  },
  {
    "name": "(GMT+08:00) Malaysia Time - Kuala Lumpur",
    "value": "Asia/Kuala_Lumpur"
  },
  {
    "name": "(GMT+08:00) Malaysia Time - Kuching",
    "value": "Asia/Kuching"
  },
  {
    "name": "(GMT+08:00) Philippine Standard Time",
    "value": "Asia/Manila"
  },
  {
    "name": "(GMT+08:00) Singapore Standard Time",
    "value": "Asia/Singapore"
  },
  {
    "name": "(GMT+08:00) Taipei Standard Time",
    "value": "Asia/Taipei"
  },
  {
    "name": "(GMT+08:00) Ulaanbaatar Standard Time",
    "value": "Asia/Ulaanbaatar"
  },
  {
    "name": "(GMT+08:45) Australian Central Western Standard Time",
    "value": "Australia/Eucla"
  },
  {
    "name": "(GMT+09:00) East Timor Time",
    "value": "Asia/Dili"
  },
  {
    "name": "(GMT+09:00) Eastern Indonesia Time",
    "value": "Asia/Jayapura"
  },
  {
    "name": "(GMT+09:00) Japan Standard Time",
    "value": "Asia/Tokyo"
  },
  {
    "name": "(GMT+09:00) Korean Standard Time - Pyongyang",
    "value": "Asia/Pyongyang"
  },
  {
    "name": "(GMT+09:00) Korean Standard Time - Seoul",
    "value": "Asia/Seoul"
  },
  {
    "name": "(GMT+09:00) Palau Time",
    "value": "Pacific/Palau"
  },
  {
    "name": "(GMT+09:00) Yakutsk Standard Time - Chita",
    "value": "Asia/Chita"
  },
  {
    "name": "(GMT+09:00) Yakutsk Standard Time - Khandyga",
    "value": "Asia/Khandyga"
  },
  {
    "name": "(GMT+09:00) Yakutsk Standard Time - Yakutsk",
    "value": "Asia/Yakutsk"
  },
  {
    "name": "(GMT+09:30) Australian Central Standard Time",
    "value": "Australia/Darwin"
  },
  {
    "name": "(GMT+10:00) Australian Eastern Standard Time - Brisbane",
    "value": "Australia/Brisbane"
  },
  {
    "name": "(GMT+10:00) Australian Eastern Standard Time - Lindeman",
    "value": "Australia/Lindeman"
  },
  {
    "name": "(GMT+10:00) Chamorro Standard Time",
    "value": "Pacific/Guam"
  },
  {
    "name": "(GMT+10:00) Chuuk Time",
    "value": "Pacific/Chuuk"
  },
  {
    "name": "(GMT+10:00) Dumont-d’Urville Time",
    "value": "Antarctica/DumontDUrville"
  },
  {
    "name": "(GMT+10:00) Papua New Guinea Time",
    "value": "Pacific/Port_Moresby"
  },
  {
    "name": "(GMT+10:00) Vladivostok Standard Time - Ust-Nera",
    "value": "Asia/Ust-Nera"
  },
  {
    "name": "(GMT+10:00) Vladivostok Standard Time - Vladivostok",
    "value": "Asia/Vladivostok"
  },
  {
    "name": "(GMT+10:30) Central Australia Time - Adelaide",
    "value": "Australia/Adelaide"
  },
  {
    "name": "(GMT+10:30) Central Australia Time - Broken Hill",
    "value": "Australia/Broken_Hill"
  },
  {
    "name": "(GMT+11:00) Bougainville Time",
    "value": "Pacific/Bougainville"
  },
  {
    "name": "(GMT+11:00) Eastern Australia Time - Currie",
    "value": "Australia/Currie"
  },
  {
    "name": "(GMT+11:00) Eastern Australia Time - Hobart",
    "value": "Australia/Hobart"
  },
  {
    "name": "(GMT+11:00) Eastern Australia Time - Melbourne",
    "value": "Australia/Melbourne"
  },
  {
    "name": "(GMT+11:00) Eastern Australia Time - Sydney",
    "value": "Australia/Sydney"
  },
  {
    "name": "(GMT+11:00) Kosrae Time",
    "value": "Pacific/Kosrae"
  },
  {
    "name": "(GMT+11:00) Lord Howe Time",
    "value": "Australia/Lord_Howe"
  },
  {
    "name": "(GMT+11:00) Macquarie Island Time",
    "value": "Antarctica/Macquarie"
  },
  {
    "name": "(GMT+11:00) Magadan Standard Time",
    "value": "Asia/Magadan"
  },
  {
    "name": "(GMT+11:00) New Caledonia Standard Time",
    "value": "Pacific/Noumea"
  },
  {
    "name": "(GMT+11:00) Ponape Time",
    "value": "Pacific/Pohnpei"
  },
  {
    "name": "(GMT+11:00) Sakhalin Standard Time",
    "value": "Asia/Sakhalin"
  },
  {
    "name": "(GMT+11:00) Solomon Islands Time",
    "value": "Pacific/Guadalcanal"
  },
  {
    "name": "(GMT+11:00) Srednekolymsk Time",
    "value": "Asia/Srednekolymsk"
  },
  {
    "name": "(GMT+11:00) Vanuatu Standard Time",
    "value": "Pacific/Efate"
  },
  {
    "name": "(GMT+12:00) Anadyr Standard Time",
    "value": "Asia/Anadyr"
  },
  {
    "name": "(GMT+12:00) Fiji Time",
    "value": "Pacific/Fiji"
  },
  {
    "name": "(GMT+12:00) Gilbert Islands Time",
    "value": "Pacific/Tarawa"
  },
  {
    "name": "(GMT+12:00) Marshall Islands Time - Kwajalein",
    "value": "Pacific/Kwajalein"
  },
  {
    "name": "(GMT+12:00) Marshall Islands Time - Majuro",
    "value": "Pacific/Majuro"
  },
  {
    "name": "(GMT+12:00) Nauru Time",
    "value": "Pacific/Nauru"
  },
  {
    "name": "(GMT+12:00) Norfolk Island Time",
    "value": "Pacific/Norfolk"
  },
  {
    "name": "(GMT+12:00) Petropavlovsk-Kamchatski Standard Time",
    "value": "Asia/Kamchatka"
  },
  {
    "name": "(GMT+12:00) Tuvalu Time",
    "value": "Pacific/Funafuti"
  },
  {
    "name": "(GMT+12:00) Wake Island Time",
    "value": "Pacific/Wake"
  },
  {
    "name": "(GMT+12:00) Wallis & Futuna Time",
    "value": "Pacific/Wallis"
  },
  {
    "name": "(GMT+13:00) New Zealand Time",
    "value": "Pacific/Auckland"
  },
  {
    "name": "(GMT+13:00) Phoenix Islands Time",
    "value": "Pacific/Enderbury"
  },
  {
    "name": "(GMT+13:00) Tokelau Time",
    "value": "Pacific/Fakaofo"
  },
  {
    "name": "(GMT+13:00) Tonga Standard Time",
    "value": "Pacific/Tongatapu"
  },
  {
    "name": "(GMT+13:45) Chatham Time",
    "value": "Pacific/Chatham"
  },
  {
    "name": "(GMT+14:00) Apia Time",
    "value": "Pacific/Apia"
  },
  {
    "name": "(GMT+14:00) Line Islands Time",
    "value": "Pacific/Kiritimati"
  }
]

class dataGenerate extends Component {
  constructor() {
    super();

    this.state = {
      openNote: false,
      eventName: '',
      stadiumLoc: '',
      time_zone: "",
      eventDate: new Date(),
      eventendDate: new Date(),
      eventTime: moment(new Date(), [moment.ISO_8601, 'HH:mm']),
      endTime: moment(new Date(new Date().setMinutes(new Date().getMinutes() + 1)), [moment.ISO_8601, 'HH:mm']),
      newData: {},

      team1LogoName: '',
      date: "",
      currentDate: "",
      //eventPhoto: '',
      statdiumImage: '',
      team1Name: '',
      team1Logo: '',
      team1Hex1: 'FFFFFF',
      team1Hex2: 'FFFFFF',
      fileName: '',
      Sfiles: {},
      team2Name: '',
      image1Checked: true,
      image2Checked: true,
      image3Checked: true,
      fileChecked: true,
      image1Message: '',
      image2Message: '',
      fileMessage: '',
      image3Message: '',
      checkDisabled: false,
      dataResponse: {},
      teamName: '',
      teamLogo: '',
      teamHex1: 'FFFFFF',
      teamHex2: 'FFFFFF',
      cols: [],
      loading: false,
      newDate: {}
    }



    this.onCreated = this.onCreated.bind(this);

    this.handleFile = this.handleFile.bind(this);
    this.handleChange = this.handleChange.bind(this);


  }



  // onCreated() {
  //   const cpElem = this.colorPicker.element.nextElementSibling;
  //   cpElem.insertBefore(this.colorPicker.element, cpElem.children[1]);
  // }

  onCreated() {
    const cpElem = this.colorPicker.element.nextElementSibling;
    cpElem.insertBefore(this.colorPicker.element, cpElem.children[2]);
    // console.log('====================================', cpElem.insertBefore(this.colorPicker.element, cpElem.children[2]))
    // console.log("VALUE IS ", cpElem)
    // console.log('====================================')
  }


  handleeventName = evt => {
    try {
      this.setState({ eventName: evt.target.value });
    } catch (err) {
      console.log("error at handling EventName in dataGeneration");
    }
  };

  handlestadiumLoc = evt => {
    try {
      this.setState({ stadiumLoc: evt.target.value });
    } catch (err) {
      console.log("error at handling StadiumLoc in dataGeneration");
    }
  };

  handleeventDate = evt => {
    try {
      let today = new Date()
      this.setState({
        eventDate: evt,
        eventTime: moment(today, [moment.ISO_8601, 'HH:mm']),
        endTime: moment(new Date(today.setMinutes(today.getMinutes() + 1)), [moment.ISO_8601, 'HH:mm']),
        eventendDate: evt,
      })
    } catch (err) {
      console.log("error at handling EventDate in dataGeneration");

    }
  }

  handleeventendDate = evt => {
    try {
      let today = new Date()
      this.setState({
        eventendDate: evt,
        // eventTime: moment(today, [moment.ISO_8601, 'HH:mm']),
        endTime: moment(new Date(today.setMinutes(today.getMinutes() + 1)), [moment.ISO_8601, 'HH:mm'])
      })
    } catch (err) {
      console.log("error at handling EventDate in dataGeneration");

    }
  }

  handleeventTime = evt => {
    try {
      this.setState({
        eventTime: moment(evt, [moment.ISO_8601, 'HH:mm']),
      }, () => {
        this.handleEndTime(new Date(evt.setMinutes(evt.getMinutes() + 1)));
      })
    } catch (err) {
      console.log("error at handling EventTime in dataGenearation");

    }
  }

  handleEndTime = evt => {
    try {
      const minTime = moment(this.state.eventTime.toDate(), [moment.ISO_8601, 'HH:mm'])
      const maxTime = moment("24:00", "HH:mm");
      if (minTime.isBefore(evt) && maxTime.isAfter(evt)) {
        //Here is corect time
        this.setState({
          endTime: moment(evt, [moment.ISO_8601, 'HH:mm'])
        })
      }
      else {
        // alert("Select a valid time")
        document.getElementById("myspan").innerHTML="Invalid Time";

      }
    } catch (err) {
      console.log("error at handling EndTime in dataGenearation", err);
    }
  }


  onTimezoneChange = (event) => {
    var tz = event.target.value
    console.log(tz,"hgh");
    this.setState({
      eventTime: moment(new Date((this.state.eventTime).toDate()).toLocaleString('en-US', { timeZone: tz })),
      endTime: moment(new Date((this.state.endTime).toDate()).toLocaleString('en-US', { timeZone: tz })),
      time_zone : event.target.value
    })
  }

  /******************************************************************** */


  handleteam1Name = evt => {
    try {
      this.setState({
        team1Name: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team A Name in dataGenearation");

    }
  }


  handleteam2Name = evt => {
    try {
      this.setState({
        checkDisabled: true,
        team2Name: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team B Name in dataGenearation");
    }
  }


  handleteam1Logo = evt => {
    try {
      this.setState({
        team1Logo: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team B LOGO in dataGenearation");
    }
  }


  handleteam2Logo = evt => {
    try {
      this.setState({
        team2Logo: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team B LOGO in dataGenearation");
    }
  }


  handleteam1Hex1 = evt => {
    try {
      this.setState({
        team1Hex1: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team A hex1 in dataGenearation");
    }
  }

  handleteam2Hex1 = evt => {
    try {
      this.setState({
        team2Hex1: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team B hex1 in dataGenearation");
    }
  }


  handleteam1Hex2 = evt => {
    try {
      this.setState({
        team1Hex2: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team A hex2 in dataGenearation");
    }
  }


  handleteam2Hex2 = evt => {
    try {
      // console.log("EVENT", evt.target.value);

      this.setState({
        team2Hex2: evt.target.value
      })
    } catch (err) {
      console.log("error at handling team B hex2 in dataGenearation");
    }
  }


  /********************************************************************************** */

  /**********current date************* */

  componentDidMount() {
    this.getDate();
  }

  getDate = () => {
    var date = new Date().toDateString();
    this.setState({ date });
  };

  /***************************************** */

  handleChange(date) {
    this.setState({
      startDate: date
    });
  }

  /*******************time and date******************************** */

  componentWillMount = () => {
    const date = new Date();
    const dateAndTime = date.toISOString().split("T");
    const time = dateAndTime[1].split(":");
    const final = dateAndTime[0] + "T" + time[0] + ":" + time[1];
    this.setState({
      currentDate: final
    });
  };
  // removeEvent = () => {

  //   this.setState({
  //     eventPhoto: ''
  //   })
  //   document.getElementById("eventPhoto").value = ""
  // }
  removeAsset = () => {
    this.state.checkDisabled = true
    this.setState({
      team1LogoName: ''
    })
    document.getElementById("team1").value = ""
  }
  removeStadium = () => {
    this.state.checkDisabled = true
    this.setState({
      statdiumImage: ''
    })
    document.getElementById("stadiumImage").value = ""
  }
  removeFile = () => {

    this.state.checkDisabled = false
    this.state.team1Hex1 = 'FFFF'
    this.state.team1Hex2 = 'FFFF'
    this.setState({
      fileName: ''
    })
    document.getElementById("file").value = ""
    document.querySelector('input[id=TeamHex1').value = " "
    document.querySelector('input[id=TeamHex2').value = " "
  }
  getName = evt => {


    if (document.querySelector('input[id=stadiumImage]').files[0]) {
      this.state.checkDisabled = false
      console.log(document.querySelector('input[id=stadiumImage]').files[0].size, document.querySelector('input[id=stadiumImage]').files[0].type)

      this.setState({
        statdiumImage: document.querySelector('input[id=stadiumImage]').files[0].name
      })
      if (document.querySelector('input[id=stadiumImage]').files[0].type == "image/jpeg" ||
        document.querySelector('input[id=stadiumImage]').files[0].type == "image/png" ||
        document.querySelector('input[id=stadiumImage]').files[0].type == "image/svg+xml") {
        if (document.querySelector('input[id=stadiumImage]').files[0].size >= 5000000) {
          this.state.image2Checked = false
          this.state.image2Message = 'Image should be less than 5 MB in size'
        } else {
          this.state.image2Checked = true
          this.checkDisabled()
        }
      }
      else {
        this.state.image2Checked = false
        this.state.image2Message = 'Only Images are accepted'
        this.checkDisabled()
        // console.log(this.state.fileChecked)
      }

    }

    if (document.querySelector('input[id=file]').files[0]) {
      this.state.checkDisabled = false
      this.setState({
        fileName: document.querySelector('input[id=file]').files[0].name
      })
    }

    // if (document.querySelector('input[id=eventPhoto]').files[0]) {
    //   this.setState({
    //     eventPhoto: document.querySelector('input[id=eventPhoto]').files[0].name
    //   })
    //   if (document.querySelector('input[id=eventPhoto]').files[0].type == "image/jpeg" ||
    //     document.querySelector('input[id=eventPhoto]').files[0].type == "image/png" ||
    //     document.querySelector('input[id=eventPhoto]').files[0].type == "image/svg+xml") {
    //     if (document.querySelector('input[id=eventPhoto]').files[0].size >= 5000000) {
    //       this.state.image1Checked = false
    //       this.state.image1Message = 'Image should be less than 5 MB in size.'
    //     } else {
    //       this.state.image1Checked = true
    //       this.checkDisabled()
    //     }
    //   }
    //   else {
    //     this.state.image1Checked = false
    //     this.state.image1Message = 'Only Images are accepted'
    //     this.checkDisabled()
    //   }

    // }

    if (document.querySelector('input[id=team1]').files[0]) {
      this.state.checkDisabled = false
      this.setState({
        team1LogoName: document.querySelector('input[id=team1]').files[0].name
      })
      if (document.querySelector('input[id=team1]').files[0].type == "image/jpeg" ||
        document.querySelector('input[id=team1]').files[0].type == "image/png" ||
        document.querySelector('input[id=team1]').files[0].type == "image/svg+xml") {
        if (document.querySelector('input[id=team1]').files[0].size >= 5000000) {
          this.state.image3Checked = false
          this.state.image3Message = 'Image should be less than 5 MB in size.'
        } else {
          this.state.image3Checked = true
          this.checkDisabled()
        }
      }
      else {
        this.state.image3Checked = false
        this.state.image3Message = 'Only Images are accepted'
        this.checkDisabled()
      }
    }
  }
  checkDisabled() {
    this.state.checkDisabled = false
    if (this.state.image2Checked && this.state.image3Checked && this.state.fileChecked) {
      this.state.checkDisabled = false
    }
  }
  handleChange = date => event => {
    this.setState({ [date]: new Date(event.target.value).toLocaleString() });
  };
  sendDate = event => {
    event.preventDefault();
    this.props.ShowNotification("Note Status: ", "Reminder set", "success");
    this.props.reminder(this.state.date, this.props.noteID);
    this.handleClose();
  };
  checkFile(e) {
    // alert(e.target.files[0].type)
    if (e.target.files[0] && e.target.files[0].type == "application/vnd.oasis.opendocument.spreadsheet") {
      if (e.target.files[0].size >= 5000000) {
        this.state.fileChecked = false
        this.state.fileMessage = 'File should be less than 5 MB'
      } else {
        this.handleFile()
        this.state.fileChecked = true
      }
    }
    else {
      this.state.fileChecked = false
      this.state.fileMessage = 'Only ods files are accepted'
      // console.log(this.state.fileChecked)
    }
  }
  checkImage1(e) {
    // alert(e.target.files[0].type)
    if (e.target.files[0].type == "image/jpeg" || e.target.files[0].type == "image/png") {
      if (e.target.files[0].size >= 5000000) {
        this.state.fileChecked = false
        this.state.fileMessage = 'File should be less than 5 MB'
      } else {
        this.handleFile()
        this.state.fileChecked = true
      }
    }
    else {
      this.state.fileChecked = false
      this.state.fileMessage = 'Only ods files are accepted'
      console.log(this.state.fileChecked)
    }
  }
  checkImage2(e) {
    // alert(e.target.files[0].type)
    if (e.target.files[0].type == "image/jpeg" || e.target.files[0].type == "image/png") {
      if (e.target.files[0].size >= 5000000) {
        this.state.fileChecked = false
        this.state.fileMessage = 'File should be less than 5 MB'
      } else {
        this.handleFile()
        this.state.fileChecked = true
      }
    }
    else {
      this.state.fileChecked = false
      this.state.fileMessage = 'Only ods files are accepted'
      // console.log(this.state.fileChecked)
    }
  }
  checkImage3(e) {
    // alert(e.target.files[0].type)
    if (e.target.files[0].type == "image/jpeg" || e.target.files[0].type == "image/png") {
      if (e.target.files[0].size >= 5000000) {
        this.state.fileChecked = false
        this.state.fileMessage = 'File should be less than 5 MB'
      } else {
        this.handleFile()
        this.state.fileChecked = true
      }
    }
    else {
      this.state.fileChecked = false
      this.state.fileMessage = 'Only ods files are accepted'
      // console.log(this.state.fileChecked)
    }
  }

  handleFile = () => {
    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
      /* Get first worksheet */

      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      if (Object.entries(ws).length == 0) {
        this.state.fileChecked = false
        this.state.fileMessage = 'Empty file cannot be accepted'
        this.checkDisabled()
      }
      else {
        this.state.fileChecked = true
        /* Convert array of arrays */
        const Fdata = XLSX.utils.sheet_to_json(ws);
        let myCommaField = [];
        let mycolor = [];
        Fdata.forEach(element => {
          myCommaField.push(Object.entries(element).flat())
          for (var i = 0; i < myCommaField[0].length; i++) {
            if (myCommaField[0][i].includes(",")) {
              mycolor.push(myCommaField[0][i]);
            }
          }
          myCommaField = [];
        })
        var filteredArray = mycolor.filter(function (item, pos) {
          return mycolor.indexOf(item) == pos;
        });
        this.setState({
          team1Hex1: filteredArray[0].split(",")[0],
          team1Hex2: filteredArray[0].split(",")[1]
        })
        document.querySelector('input[id=TeamHex1').value = filteredArray[0].split(",")[0];
        document.querySelector('input[id=TeamHex2').value = filteredArray[0].split(",")[1];
        this.setState({ fileJSON: Fdata, cols: make_cols(ws['!ref']) }, () => {
          let seatsSectionKeys = [];
          Object.keys(this.state.fileJSON[0]).forEach(function (element) {
            if (element !== 'time' && element.startsWith("_") !== true && element.length > 4 !== true) {
              seatsSectionKeys.push(element);
            }
          });
          this.setState({
            SelectOptions: seatsSectionKeys.sort()
          })

          // seatSection(this.state.Fdata).then(res=>{
          //   console.log(res)
          // })
        });
        this.checkDisabled()
      }
    };
    if (rABS) {
      reader.readAsBinaryString(document.querySelector('input[id=file]').files[0]);

    } else {
      reader.readAsArrayBuffer(document.querySelector('input[id=file]').files[0]);

    };
  }
  /******************************************************************************** */

  handleToggle = (e) => {
    e.preventDefault();
    this.setState({ loading: true })
    try {
      this.setState({ openNote: !this.state.openNote });
      if (
        this.state.eventName !== "" || this.state.stadiumLoc !== "" ||
        this.state.eventDate !== "" || this.state.eventTime !== "" || this.state.endTime !== "" || this.state.eventendDate !== "")

        if (
          this.state.team1Name !== '' || this.state.team1LogoName !== '' || this.state.team1Hex1 !== '' || this.state.team1Hex2 !== '' ||
          this.state.team2Name !== '') {

          const data = {
            //   userId: localStorage.getItem("user_id"),

            // need userId to send data to firebase
            eventName: this.state.eventName,
            stadiumLoc: this.state.stadiumLoc,
            time_zone: this.state.time_zone,
            eventDate: this.state.eventDate.toISOString(),
            eventendDate: this.state.eventendDate.toISOString(),
            eventTime: this.state.eventTime.toISOString(),
            endTime: this.state.endTime.toISOString(),
            team1Name: this.state.team1Name,
            team1LogoName: this.state.team1LogoName,
            team1LogoURL: this.state.team1LogoURL || '',
            team1Hex1: this.state.team1Hex1,
            team1Hex2: this.state.team1Hex2,
            team2Name: this.state.team2Name,
            fileName: this.state.fileName,
            seatsJSON: this.state.fileJSON,
            seatKeys: this.state.SelectOptions
          };
          console.log(data,"jvfhgfh");
          // data.eventTime = data.eventTime.replace(data.eventTime.substring(0, 10), data.eventDate.substring(0, 10));
          // data.eventTime = data.eventTime.replace(data.eventTime.substr(8,2), Number(data.eventTime.substr(8,2))+1)
          // data.endTime = data.endTime.replace(data.endTime.substring(0, 10), data.eventDate.substring(0, 10));
          // data.endTime = data.endTime.replace(data.endTime.substr(8,2), Number(data.endTime.substr(8,2))+1)
          // debugger
          let myTime = new Date().toISOString();
          //  if(data.eventTime > myTime){
          generateData(data).then((response) => {
            axios.get('http://localhost:5000/refresh')
              .then(function (response) {
                // handle success
                // console.log("Updated Sucessfullyyyyyyyyyyyyyyyyy");
              })
              .catch(function (error) {
                // handle error
                console.log(error);
              })
              .finally(function () {
                // always executed
              });
            this.setState({
              dataResponse: response
            })
            setTimeout(() => {
              window.location.href = "/eventScreen"
            }, 100);
          })
            .catch(err => {
              console.log(err);
            });
          this.setState({
            eventName: "",
            stadiumLoc: "",
            eventDate: new Date(),
            eventTime: new Date(),
            endTime: new Date(),
            team1Name: '',
            team1Logo: '',
            team1Hex1: '',
            fileName: '',
            team1Hex2: '',
            team2Name: '',
            statdiumImage: '',
            // eventPhoto: '',
            cols: []
          });
          // }
          // else{
          //   alert("Event cannot be created, the time chosen has already passed, kindly choose the right time");
          // }

        }
    } catch (err) {
      console.log("error at handleToggle in generatingData");
    }
  };



  RedirectUser = () => {
    this.props.history.push("/eventScreen");
  };

  /********************************************************************************************************************************** */


  getInfoFromAssests = () => {


    // componentDidMount() {




    getAssetsInfo()
      .then((response) => {
        // console.log("response", response);
        this.setState({

          team1LogoURL: response[0].teamLogoURL,
          team1LogoName: response[0].teamLogoName,
          team1Name: response[0].teamName,
          team1Logo: response[0].teamLogoURL,
          team1Hex1: response[0].teamHex1,
          team1Hex2: response[0].teamHex2,



        });
        document.querySelector('input[id=TeamHex1').value = this.state.team1Hex1;
        document.querySelector('input[id=TeamHex2').value = this.state.team1Hex2;
        // console.log("fetchEvent", this.state.newData);
      })
      .catch((error) => {
        console.log(error);
      });
    // }


  }



  /*********************************************************************************************************************************** */

  slideCards = () => {
    try {
      this.setState({ slideCards: !this.state.slideCards });
    } catch (err) {
      console.log("error at slideCards in dashBoard");
    }
  };
  /**
   * @description:it handles the cards style
   */
  handleCardStyle = () => {
    try {
      this.setState({ cardStyles: !this.state.cardStyles });
    } catch (err) {
      console.log("error at handleCardStyle in dashBoard");
    }
  }

  /****************************************************************************************************************************** */




  //  Comp() {
  // The first commit of Material-UI


  // const classes = useStyles();

  // handleDateChange(date) {
  //   setSelectedDate(date);
  // }

  /******************************************************************************************************************************* */
  render() {

    const { date } = this.state


    const { classes } = this.props;

    // const classes = useStyles();
    // const { classes } = this.props;
    const slidingCards = this.state.slideCards ? "afterSlide" : "beforeSlide";





    return (
      <MuiThemeProvider theme={theme} location={this.props.location}>

        <div className={classes.root}>

          <div className={slidingCards} id={slidingCards}>

            <div style={{ position: 'relative', }}>
              <TopBar
                slideCards={this.slideCards}
                props={this.props}
                notePropsToApp={this.handleCardStyle}
                handleNavigation={this.handleNavigation}
              />
            </div>
          </div>



          {this.state.loading ? <div class="datagenerate">
            <div
              style={{
                textAlign: "center",
                height: "100px",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                top: "45vh",
                left: "35vw"
              }}
            >
              <Loader type="Circles" color="#422963" height="100%" width="100px" />
            </div>
          </div> :
            <div class="datagenerate" >
              <form onSubmit={this.handleToggle}>
                <h4 style={{ textDecorationLine: 'underline', fontWeight: ' bold', marginTop: '20px' }}>Event Information :</h4>
                <section class="sectionClass">
                  <div class="container-fluid">
                    <div class="row sectRow">

                      <div class="col-md-4 col-sm-6" >

                        <div className='labelDivLeft'>
                          <label style={{ fontWeight: 'bold' }}>EventName:<span className="red">*</span>  </label>
                        </div>

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold' }}> Venue Name:<span className="red">*</span>   </label>
                        </div>

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold' }}> Time Zone <span className="red">*</span>  </label>
                        </div>

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold' }}>Event Start Date: <span className="red">*</span>  </label>
                        </div>

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold' }}>Event Start Time: <span className="red">*</span>  </label>
                        </div>

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold' }}>Event End Date:  <span className="red">*</span>   </label>
                        </div>

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold' }}>Event End Time: <span className="red">*</span>  </label>
                        </div>
         
                        {/* <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold' }}> Event Photo:<span className="red">*</span>   </label>
                        </div> */}

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold' }}> Event Image:<span className="red">*</span>   </label>
                        </div>

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold' }} > Upload ods: <span className="red">*</span> </label>
                        </div>
                      </div>


                      <div class="col-md-8 col-sm-6">

                        <div className='labelDivRight' >
                          <Input
                            className="eventName"
                            // disableUnderline={true}
                            id="eventName"
                            style={{}}
                            value={this.state.eventName}
                            onChange={this.handleeventName}
                            required
                          />
                        </div>


                        <div className='labelDivRight' >
                          <Input
                            className="stadLoc"
                            // disableUnderline={true}
                            id="stadLoc"
                            style={{}}
                            value={this.state.stadiumLoc}
                            onChange={this.handlestadiumLoc}
                            required
                          />
                        </div>

                        <div id="utc-time" className="zonetime focus-visible-only">
                          <select name="time_zone" className="timezonewidth focus-visible-only"  onChange={this.onTimezoneChange}>
                            <option>Select TimeZone</option>
                            {timeZones.map(function (time, index) {
                              return <option value={time.value}>{time.name}</option>;
                            })}
                          </select>
                        </div>

                        <div className='labelDivRight'>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Grid container className={classes.grid}>
                              <KeyboardDatePicker
                                clearable={true}
                                id="mui-pickers-date"
                                format="MMMM dd, yyyy"
                                minDate={new Date()}
                                value={this.state.eventDate}
                                onChange={this.handleeventDate}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                              />
                            </Grid>
                          </MuiPickersUtilsProvider>
                        </div>

                        <div className='labelDivRight' >
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Grid container className={classes.grid}>
                              <KeyboardTimePicker
                                mask="__:__ _M"
                                value={this.state.eventTime}
                                onChange={this.handleeventTime}
                                keyboardIcon={<FaRegClock style={{fontSize: '22px' }} />}
                              />
                            </Grid>
                          </MuiPickersUtilsProvider>
                        </div>

                        <div className='labelDivRight'>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Grid container className={classes.grid}>
                              <KeyboardDatePicker
                                clearable={true}
                                id="mui-pickers-date"
                                format="MMMM dd, yyyy"
                                minDate={new Date()}
                                value={this.state.eventendDate}
                                onChange={this.handleeventendDate}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                              />
                            </Grid>
                          </MuiPickersUtilsProvider>
                        </div>

                        <div className='labelDivRight' >
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <div>
                        <span id="myspan"></span>
                        </div>
                            <Grid container className={classes.grid}>
                              <KeyboardTimePicker
                                mask="__:__ _M"
                                value={this.state.endTime}
                                onChange={this.handleEndTime}
                                keyboardIcon={<FaRegClock style={{ fontSize: '22px' }} />}
                              />
                            </Grid>
                          </MuiPickersUtilsProvider>
                          
                        </div>
                        
                        

                        {/* <div className='labelDivRight' >
                          <label for="eventPhoto" className="MyButton" onMouseLeave={this.getName}>Upload Image</label>
                          {this.state.image1Checked ? null :
                            <div className="labelDivRight">
                              <span className="red">{this.state.image1Message}</span>
                            </div>}
                          {!this.state.image1Checked ? null :
                            <div>
                              <label className="setMyPadding">{this.state.eventPhoto}</label>
                              {this.state.eventPhoto ? <FaTrash onClick={this.removeEvent} /> : null}
                            </div>}
                          <input id="eventPhoto" style={{ visibility: 'hidden', width: '1%' }} type="file" accept=".jpg, .jpeg, .png" required></input>
                        </div> */}



                        <div className='labelDivRight' >
                          <label for="stadiumImage" className="MyButton" onMouseLeave={this.getName}>Upload Image <FaInfoCircle title="Accepted formats are .png, .jpeg, .jpg and Accepted image dimensions are ()" style={{ marginLeft: '0.5rem' }} /></label>
                          {this.state.image2Checked ? null :
                            <div className="labelDivRight">
                              <span className="red">{this.state.image2Message}</span>
                            </div>
                          }
                          {!this.state.image2Checked ? null :
                            <div>
                              <label className="setMyPadding">{this.state.statdiumImage}</label>
                              {this.state.statdiumImage ? <FaTrash onClick={this.removeStadium} /> : null}
                            </div>}
                          <input id="stadiumImage" style={{ visibility: 'hidden', width: '1%' }} type="file" accept=".jpg, .jpeg, .png" required></input>
                        </div>



                        <div className='labelDivRight' >
                          <label for='file' className="MyButton" onMouseLeave={this.getName} required> Choose File <FaInfoCircle title="Accepted formats are .ods" style={{ marginLeft: '0.5rem' }} /></label>
                          {this.state.fileChecked ? null :
                            <div className="labelDivRight">
                              <span className="red">{this.state.fileMessage}</span>
                            </div>}
                          {!this.state.fileChecked ? null :
                            <div>
                              <label className="setMyPadding">{this.state.fileName}</label>
                              {this.state.fileName ? <FaTrash onClick={this.removeFile} /> : null}
                            </div>}
                          <input type="file" style={{ visibility: 'hidden' }} id="file" accept={SheetJSFT} onChange={(e) => this.checkFile(e)} accept=".ods" required />
                        </div>

                      </div>
                    </div>
                  </div>

                </section>


                {/*********************************************************************************************************************** */}

                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <h4 style={{ marginTop: 10, textDecorationLine: 'underline', fontWeight: ' bold' }}>Team Information :</h4>


                  {/* <div>
                <Button
                  id="button12"
                  type="submit"
                  className="ButtonStyle"
                  onClick={this.getInfoFromAssests}
                  title="Access Info from Assets"
                >
                  Assets
              </Button>
              </div> */}

                </div>

                {/************************************************************************************************************************** */}


                {/*****************************************************Team1**************************************************************** */}

                <section class="sectionClass">

                  <div class="container-fluid">
                    <div class="row sectRow">

                      <div class="col-md-4 col-sm-6">

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold' }}>Team 1 Name: <span className="red">*</span>  </label>
                        </div>

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold', }}>Team 1 Logo: <span className="red">*</span>  </label>
                        </div>

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold' }}>Team 1 Primary Color Hex: <span className="red">*</span> </label>
                        </div>

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold' }} >Team 1 Secondary Color Hex: <span className="red">*</span>  </label>
                        </div>

                        <div className='labelDivLeft' >
                          <label style={{ fontWeight: 'bold' }}>Team 2 Name: <span className="red">*</span>  </label>
                        </div>

                      </div>


                      <div class="col-md-8 col-sm-6">

                        <div className='labelDivRight' >
                          <Input
                            // disableUnderline={true}
                            style={{}}
                            value={this.state.team1Name}
                            onChange={this.handleteam1Name}
                            required
                          />
                        </div>


                        <div className='labelDivRight' >
                          <label for="team1" className="MyButton" style={{ marginBottom: '0' }} onMouseLeave={this.getName}>Upload Image</label>
                          {!this.state.image3Checked ? null :
                            <div>
                              <label className="setMyPadding" required>{this.state.team1LogoName}</label>
                              {this.state.team1LogoName ? <FaTrash onClick={this.removeAsset} /> : null}
                            </div>}
                          <input id="team1" style={{ visibility: 'hidden' }} type="file" accept=".jpg, .jpeg, .png" required></input>
                          {/* <input type='file' id="team1" style={{ outline: 'none' ,margin:'5px' }} />
                    <img src={this.state.team1LogoURL} width="50" height="50" alt="teamLogo" /> */}
                        </div>
                        {this.state.image3Checked ? null :
                          <div className="labelDivRight">
                            <span className="red">{this.state.image3Message}</span>
                          </div>}






                        <div className='labelDivRight' >
                          <input readonly id="TeamHex1" className=" ColorPickerStyle" style={{ backgroundColor: this.state.team1Hex1 ? '#' + this.state.team1Hex1 : this.state.team1Hex1, padding: '7' }}  ></input>
                          {/* <input id="TeamHex1" className="jscolor ColorPickerStyle" style={{ backgroundColor: this.state.team1Hex1 ? '#' + this.state.team1Hex1 : this.state.team1Hex1, padding: '7' }} onBlur={this.handleteam1Hex1} required></input> */}

                        </div>

                        <div className='labelDivRight' >
                          <input readonly id="TeamHex2" className=" ColorPickerStyle" style={{ backgroundColor: this.state.team1Hex2 ? '#' + this.state.team1Hex2 : this.state.team1Hex2, padding: '7' }}   ></input>
                          {/* <input id="TeamHex2" className="jscolor ColorPickerStyle" placeholder="Choose Color" onBlur={this.handleteam1Hex2} required></input> */}

                        </div>

                        <div className='labelDivRight' >
                          <Input
                            // disableUnderline={true}
                            style={{}}
                            value={this.state.team2Name}
                            onChange={this.handleteam2Name}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                </section>

                {/* <div style={{ display: 'flex', flexDirection: 'row', }}>
                  <div className="LogoClass">
                    <p style={{ fontWeight: 'bold', marginLeft: '-50px' }}>Team 2 Logo :
                     <input type='file' id="team2" style={{ outline: 'none', paddingLeft: '70px' }} />
                      <img src={this.state.team2LogoURL} width="50" height="50" alt="teamLogo" />
                    </p>
                  </div>
                </div> */}


                {/*******************************************TEAM 2************************************************************************* */}

                <section class="sectionClass">

                  <div class="container-fluid">
                    <div class="row sectRow">

                      <div class="col-md-4 col-sm-6">
                        {/*
                     <div className='labelDivLeft' >
                      <label style={{ fontWeight: 'bold' }}>Team 2 Name: </label>
                    </div> */}

                        {/* <div className='labelDivLeft' >
                      <label style={{ fontWeight: 'bold', }}>Team 2 Logo : </label>
                    </div>

                    <div className='labelDivLeft' >
                      <label style={{ fontWeight: 'bold' }}>Team 2 Primary Color Hex: </label>
                    </div>

                    <div className='labelDivLeft' >
                      <label style={{ fontWeight: 'bold' }} >Team 2 Secondary Color Hex: </label>
                    </div> */}


                      </div>


                      <div class="col-md-8 col-sm-6">

                        {/* <div className='labelDivRight' >
                      <Input
                        // disableUnderline={true}
                        style={{}}
                        value={this.state.team2Name}
                        onChange={this.handleteam2Name}
                      />
                    </div> */}


                        {/* <div className='labelDivRight' style={{ display: 'flex', flexDirection: 'row' }}>
                      <label for="team2" className="MyButton" onMouseLeave={this.getName}>Upload Image</label>
                      <label className="setMyPadding">{this.state.team2LogoName}</label>
                      {this.state.team2LogoName ? <FaTrash onClick={this.removeMe} /> : null}
                      <input id="team2" style={{ visibility: 'hidden' }} type="file"></input>

                      {/*
                      <input type='file' id="team2" style={{ outline: 'none' ,margin:'5px' }} />
                      <img src={this.state.team2LogoURL} width="50" height="50" alt="teamLogo" />
                    </div>

                    <div className='labelDivRight' >
                        <input id="Team2Hex1" className="jscolor ColorPickerStyle" onBlur={this.handleteam2Hex1}></input>
                    </div>


                    <div className='labelDivRight'>
                      <input id="Team2Hex2" className="jscolor ColorPickerStyle" onBlur={this.handleteam2Hex2}></input>
                  </div> */}

                      </div>


                    </div>
                  </div>

                </section>

                {/******************************************************************************************************************************* */}

                <div>
                  <Button
                    // id="CloseButtonNote"
                    id="button12"
                    className="ButtonStyle"
                    type="submit"
                  // style={{ backgroundColor: "transparent" }}
                  //disabled={!this.state.checkDisabled}
                  >
                    Save
                  </Button>
                </div>
              </form>
            </div>

          }


        </div>
      </MuiThemeProvider>
    )
  }

}



export default withStyles({ withTheme: true })(dataGenerate);





